import { createContext, useContext } from 'react';

const OverrideFormatLocaleContext = createContext<string | undefined>(undefined);

/**
 * Provider for an override format locale across the whole application. Most applications will not need this. Primary
 * use case is when your application does not use Global Settings and you need to set a format locale that is separate
 * from the application locale.
 */
export const OverrideFormatLocaleProvider = OverrideFormatLocaleContext.Provider;

/**
 * This hook specifically returns the value from the `OverrideFormatLocaleProvider`. Most use cases should use
 * `useFormatLocale` instead. The `useFormatLocale` hook provides more a robust means of figuring out which format
 * locale to use.
 *
 * @returns configured default format locale
 */
export const useOverrideFormatLocale = () => {
  return useContext(OverrideFormatLocaleContext);
};
